<template>
    <div class="container my-5">
      <div class="row pb-4 text-center">
        <div class="col">
          <div class="display-2 font-weight-bolder">Tumblr Widget</div>
          <div class="h3 mt-3">
            Embed your Tumblr feed in any website.
          </div>
        </div>
      </div>
    </div>
</template>


<script>
export default {
  name: 'BaseBrandedHeader',
};
</script>
